<template>
  <div>
    <base-header class="pb-6 bg-gradient-dark">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Credit Notes</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-breadcrumb></route-breadcrumb>
          </nav>
        </div>
      </div>
      <!-- Card stats -->
      <div class="row">
        <div class="col-xl-3 col-md-6">
          <stats-card
            title="Outstanding Notes"
            type="gradient-info"
            :sub-title="
              notes && notes.length
                ? `${notes.filter((i) => i.status === 'outstanding').length}`
                : '0'
            "
            icon="fas fa-users"
          >
          </stats-card>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--6">
      <!--Widgets-->

      <div class="row">
        <div class="col-12">
          <notes-table
            :notes="notes"
            @toggle="toggleStatus"
            @remove="handleRemove"
          />
        </div>
      </div>
      <!--End Widgets-->
    </div>
  </div>
</template>

<script>
import NotesTable from './NotesTable'

export default {
  name: 'NotesList',
  components: { NotesTable },
  data() {
    return {
      notes: []
    }
  },
  methods: {
    async fetchData() {
      this.loader = this.$loading.show()
      await this.axios
        .get(process.env.VUE_APP_ROOT_API + '/api/v1/affiliates/invoices/')
        .then(({ data }) => {
          this.notes = data
        })
        .catch(() =>
          this.$notify({ type: 'danger', message: 'Something went wrong!' })
        )
      this.loader.hide()
    },
    async toggleStatus(row) {
      this.loader = this.$loading.show()
      await this.axios
        .put(
          process.env.VUE_APP_ROOT_API +
            '/api/v1/affiliates/invoices/' +
            row.id,
          {
            status: row.status === 'paid' ? 'outstanding' : 'paid'
          }
        )
        .then(({ data }) => {
          this.notes.find((i) => i.id === data.id).status = data.status
        })
        .catch(() =>
          this.$notify({ type: 'danger', message: 'Something went wrong!' })
        )
      this.loader.hide()
    },
    async handleRemove(row) {
      this.loader = this.$loading.show()
      await this.axios
        .delete(
          process.env.VUE_APP_ROOT_API + '/api/v1/affiliates/invoices/' + row.id
        )
        .then((_) => {
          this.notes.find((i) => i.id === row.id).status = 'deleted'
          this.$notify({
            type: 'warning',
            message: `Removed Invoice - ${row.id}`
          })
        })
        .catch(() =>
          this.$notify({ type: 'danger', message: 'Something went wrong!' })
        )
      this.loader.hide()
    }
  },
  mounted() {
    this.fetchData()
  }
}
</script>

<style scoped></style>
